import { render, staticRenderFns } from "./ShopifySSO.vue?vue&type=template&id=e5164392"
import script from "./ShopifySSO.vue?vue&type=script&lang=js"
export * from "./ShopifySSO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports